export function isChatHostPath(pathname: string): boolean {
  return (
    pathname === '/' ||
    ['/chat', '/ai-inbox'].some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  );
}
